module.exports = __webpack_public_path__ + "media/bg.4109b4a1.mp4";